/*
	@ Smooth scroll on anchor links
*/

$('a[href^="#"]:not([href="#"])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {

			var offset = 0

			var scroll = target.offset().top

			if($(this).data('scroll-offset')){
				var scroll = scroll + $(this).data('scroll-offset')
			}

			var scroll = scroll + offset

			$(document.body).removeClass('megamenu-is-open')

			$('html,body').animate({
				scrollTop: scroll
			}, 800);

			return false;

		}
	}
});
